import React, { useCallback, useMemo } from "react";
import {
  Card,
  Checkbox,
  GridLegacy,
  IconButton,
  MenuItem,
  Select,
  TableCell,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import FormElement from "../../components/JamezzTable/FormElement";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { useDialog } from "../../licensing/utils/DialogProvider";
import useJTFilter from "../../components/JamezzTable/V2/useJTFilter";
import { Add, FreeBreakfast, Lock } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import { connect } from "react-redux";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import Button from "../../components/CustomButtons/Button";
import { unwrap } from "../../unwrap";
import FormV2 from "../JamezzForm/FormV2";
import FormAsyncTC from "../../components/Forms/FormAsyncTC";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";

const endPoint = "core/campaigns";

function Campaigns(props) {
  const { reloadState, updateReloadState } = useReloadState();
  const [textField, searchFilter] = useJTFilter("name");

  const [openDialog] = useDialog();
  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Campaign name"} tKey={"campaigns.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "type",
        label: <TranslationWrapper tDefault={"Campaign type"} tKey={"campaigns.type"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "is_active_in_pos",
        label: <TranslationWrapper tDefault={"Campaign Active in POS"} tKey={"campaigns.is_active_in_pos"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "is_active_in_jamezz",
        label: <TranslationWrapper tDefault={"Campaign Active in Jamezz"} tKey={"campaigns.is_active_in_jamezz"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id} ({row.apiId})
        </TableCell>
        <TableCell style={{ width: "50%" }}>
          {isEditable ? (
            <FormElement endPoint={endPoint} name={"name"} row={row}>
              <TextField size={"small"} variant={"standard"} sx={{ width: "100%" }} />
            </FormElement>
          ) : null}
          {!isEditable ? row.name : null}
        </TableCell>
        <TableCell>
          {isEditable ? (
            <FormElement endPoint={endPoint} name={"type"} row={row}>
              <Select size={"small"} variant={"standard"}>
                <MenuItem value={"X_FOR_Y"}>X_FOR_Y</MenuItem>
                <MenuItem value={"BUY_X_PAY_Y"}>BUY_X_PAY_Y</MenuItem>
                <MenuItem value={"X_PERCENTAGE_OFF"}>X_PERCENTAGE_OFF</MenuItem>
                <MenuItem value={"XTH_ITEM_Y_PERCENTAGE_OFF"}>XTH_ITEM_Y_PERCENTAGE_OFF</MenuItem>
                <MenuItem value={"X_PER_GROUP_FOR_Y"}>X_PER_GROUP_FOR_Y</MenuItem>
                <MenuItem value={"NONE"}>NONE</MenuItem>
              </Select>
            </FormElement>
          ) : null}
          {!isEditable ? row.type : null}
        </TableCell>
        <TableCell>
          {isEditable ? (
            <FormElement endPoint={endPoint} name={"is_active_in_pos"} parseBoolToInt row={row} valueKey={"checked"}>
              <Checkbox size={"small"} variant={"standard"} />
            </FormElement>
          ) : null}
          {!isEditable ? <Checkbox checked={!!row.is_active_in_pos} color={"primary"} disabled /> : null}
        </TableCell>
        <TableCell>
          {isEditable ? (
            <FormElement endPoint={endPoint} name={"is_active_in_jamezz"} parseBoolToInt row={row} valueKey={"checked"}>
              <Checkbox size={"small"} variant={"standard"} />
            </FormElement>
          ) : null}
          {!isEditable ? <Checkbox checked={!!row.is_active_in_jamezz} color={"primary"} disabled /> : null}
        </TableCell>
      </>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Link to={`./${row.id}/edit`}>
          <Tooltip
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
          >
            <IconButton color={"primary"} simple size={"small"}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    );
  }, []);

  const filters = useMemo(() => {
    let filters = {};
    if (searchFilter) {
      filters = searchFilter;
    }
    if (props.filters) {
      filters = { ...filters, ...props.filters };
    }
    return filters;
  }, [searchFilter, props.filters]);

  const salesarea = unwrap(props.vestiging_id);
  const appTarget = unwrap(props.appTarget);
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: salesarea,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Campaigns"} tKey={"campaigns.table.title"} />} />

      {salesarea ? (
        <GridContainer>
          <GridItem xs={12}>
            {appTarget === "appv5.js" ? (
              <AuthenticationWrapper
                child={
                  <Link to={"./create"}>
                    <Button color={"success"}>
                      <Add />{" "}
                      <TranslationWrapper tDefault={"Create new campaign"} tKey={"campaigns.createNewCampaign"} />
                    </Button>
                  </Link>
                }
                permissionKey={"campaigns.create"}
              />
            ) : (
              <Typography>
                <Lock />
                <TranslationWrapper tKey={"Only supported in appv5"} />
              </Typography>
            )}
          </GridItem>
        </GridContainer>
      ) : null}
      <VestigingenFilter />
      {textField}

      {(Array.isArray(props.vestiging_id) && props.vestiging_id?.length === 1) ||
      (!Array.isArray(props.vestiging_id) && !Number.isNaN(props.vestiging_id)) ? (
        <Card sx={{ p: 2 }}>
          <FormV2
            endPoint={"core/vestigingen"}
            isSaveButtonSticky={false}
            modelId={props.vestiging_id}
            pageTitle={"Vestiging"}
            key={menukaartVestigingId}
            parseInput={{
              custom_data: (response) => {
                return response == "[]" ? {} : response ? JSON.parse(response) : {};
              },
            }}
            parseOutput={{
              custom_data: (o) => (typeof o !== "string" ? JSON.stringify(o) : o),
            }}
          >
            <ExtraCampaignOptions menukaartVestigingId={menukaartVestigingId} />
          </FormV2>
        </Card>
      ) : null}
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          <JamezzTableV2
            checkboxSelection={true}
            dense={true}
            endPoint={endPoint}
            filters={filters}
            headerIcon={<FreeBreakfast />}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={renderRowActions}
            renderSelectionActions={() => {}}
            tableTitle={<TranslationWrapper tDefault={"Campaigns"} tKey={"campaigns.table.title"} />}
            uuid={"Campaigns-diu1j209jd89jsx"}
          />
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

function ExtraCampaignOptions({ menukaartVestigingId }) {
  return (
    <FormAsyncTC
      async={{
        url:
          "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
          menukaartVestigingId,
        searchField: "naam",
      }}
      key={"campaign_discount_product-" + menukaartVestigingId}
      name={"custom_data.boomi.campaign_discount_product"}
      tDefault={"Campaign discount product"}
      tKey={"custom_data.boomi.campaign_discount_product"}
    />
  );
}

const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
    appTarget: state.filtersV2.vestiging_id?.appTarget,
  };
};

export default connect(mapStateToProps)(withStyles(Campaigns, vestigingStyle));
